import script from "./practice-assistant-form.vue?vue&type=script&setup=true&lang=js"
export * from "./practice-assistant-form.vue?vue&type=script&setup=true&lang=js"

import "./practice-assistant-form.vue?vue&type=style&index=0&id=878e0f2e&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-878e0f2e"]])

export default __exports__